"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getFragmentByPath(block, path) {
    return path.reduce((acc, val) => {
        return (acc.fragments || [])[val];
    }, block);
}
exports.default = getFragmentByPath;
//# sourceMappingURL=getFragmentByPath.js.map